import { Format } from "@/data/util/Format";

import { logError } from "@/shared/logging/errors";
import { FloatLabel } from "@/shared/ui/FloatLabel";
import { Ripple } from "@/shared/ui/Ripple";

import { TastierClient } from "@/app/TastierClient";
import { trans } from "@/app/localization/Trans";
import { BasePopover } from "@/app/popover/BasePopover";
import { Popup } from "@/app/ui/Popup";

export class TableSelectionPopover extends BasePopover {
    private $form: JQuery;
    private $submitBtn: JQuery;

    private locationId: string;

    constructor(locationId: string, locationName: string) {
        super(trans.tableSelectionPopover.title, false);

        this.$element.addClass("tableselection");
        this.locationId = locationId;

        this.$form = $('<form class="form" novalidate />').appendTo(this.$body);
        const row = $('<div class="formrow" />').appendTo(this.$form);
        row.append(
            '<div class="formcontrol"><label>' +
                trans.tableSelectionPopover.tableNumber +
                '</label><input type="number" name="tablenumber" value="" /></div>'
        );

        this.$form.append(
            '<div class="welcome">' +
                trans.tableSelectionPopover.welcomeTo +
                " " +
                Format.htmlEscape(locationName) +
                "</div>"
        );
        this.$form.append('<div class="hint">' + trans.tableSelectionPopover.hint + "</div>");
        this.$submitBtn = $('<button class="btn" type="submit">' + trans.general.continue + "</button>").appendTo(
            this.$form
        );
        Ripple.bind(
            this.$submitBtn.click((e) => {
                e.preventDefault();
                this.$form.submit();
            })
        );

        FloatLabel.bind(this.$form);
        this.$form.submit((e) => {
            e.preventDefault();
            e.stopPropagation();

            this.onSubmit();

            return false;
        });
    }

    protected onShow() {}

    protected onHide() {
        this.destroy();
    }

    protected onDestroy() {}

    private async onSubmit() {
        if (this.$submitBtn.hasClass("loading")) return;

        const numberField = this.$form.find('input[name="tablenumber"]');
        const tableNumber = numberField.val().length === 0 ? undefined : parseInt(numberField.val());
        if (tableNumber === undefined || isNaN(tableNumber) || tableNumber <= 0) {
            numberField.parent().addClass("has-error");
            return;
        } else numberField.parent().removeClass("has-error");

        this.$submitBtn.addClass("loading").prop("disabled", true);
        try {
            await TastierClient.context.allocate(this.locationId, tableNumber, undefined, false);
            this.hide();
        } catch (ex) {
            logError(ex);
            Popup.show(trans.allocation.allocationFailed);
            this.$submitBtn.removeClass("loading").prop("disabled", false);
        }
    }

    public static isAlreadyOpen() {
        return $(".app > .popover.tableselection").length !== 0;
    }
}
